import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { branchActions } from '../ActionTypes';


export const fetchBranch = () => async (dispatch) => {
  try {
    dispatch({
      type: branchActions.BRANCH_FETCH_START
    });

    const resData = await Service.GET({
      name: 'branch',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: branchActions.BRANCH_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: branchActions.BRANCH_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};
export const saveBranch = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData
    };
    dispatch({
      type: branchActions.BRANCH_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'branch',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: branchActions.BRANCH_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/branch'; }, 1000);
  } catch (error) {
    dispatch({
      type: branchActions.BRANCH_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editBranch = (branchId) => async (dispatch, getState) => {
  try {
    const { branchList } = getState().branch;
    const data = branchList.find((item) => item.Id === branchId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: branchActions.BRANCH_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: branchActions.BRANCH_RESET_FORM });

export const deleteBranch = (Id) => async (dispatch) => Service.DELETE({
  name: 'branch',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchBranch());
    return true;
  }
  throw new Error(res.message);
});
